import axios from 'axios';

export interface RouteData {
  acf: any;
  author: number;
  content: { protected: boolean; rendered: string };
  date: string;
  excerpt: { protected: boolean; rendered: string };
  featured_image_sizes?: any[];
  featured_media: number;
  id: number;
  menu_order: number;
  meta: any[];
  modified: string;
  parent: number;
  slug: string;
  status: string;
  title: { rendered: string };
  type: string;
}

export default class Wordpress {
  static apiBase(): string {
    return process.env.NODE_ENV === 'production'
      ? window.location.origin
      : process.env.VUE_APP_WP_API_BASE || 'http://localhost:8888';
  }

  static async getRoutes(): Promise<any> {
    const path = this.apiBase() + `/wp-json/wp/v2/routes`;
    const response = await axios.get(path);
    return response.data;
  }

  static async getRouteData(slug: string): Promise<RouteData> {
    const path = this.apiBase() + `/wp-json/wp/v2/get-page/?path=${slug}`;
    const response = await axios.get(path);
    return response.data;
  }

  static async getHomeData(): Promise<RouteData> {
    const path = this.apiBase() + `/wp-json/wp/v2/frontpage/`;
    const response = await axios.get(path);
    return response.data;
  }

  static async getMenuData(slug: string): Promise<any> {
    const path = this.apiBase() + `/wp-json/wp/v2/menu-location/${slug}`;
    const response = await axios.get(path);
    return response.data;
  }

  static async getOptionsData(): Promise<any> {
    const path = this.apiBase() + `/wp-json/acf/v3/options/options`;
    const response = await axios.get(path);
    return response.data;
  }
}
